import { useSharedModelController } from '../hooks/use-shared-model-controller';

export interface SideNavModel {
  collapsed: boolean;
}

export class SideNavController {
  private model: SideNavModel = initialSideNavModel();

  constructor(private updateViewState: (_: SideNavModel) => void) {}

  private update(model: SideNavModel) {
    this.model = model;
    this.updateViewState(model);
  }

  setCollapsed(collapsed: boolean) {
    this.update({ ...this.model, collapsed });
  }
}

function initialSideNavModel(): SideNavModel {
  return {
    collapsed: false,
  };
}

export function useSideNav() {
  const { model, delegate } = useSharedModelController(initialSideNavModel, SideNavController, { useTelemetry: true });

  return { sideNavModel: model, sideNavDelegate: delegate };
}
